import styled from 'styled-components';
import theme from '../../constants/theme';
import { isIE11 } from '../../helpers/utils-helpers';

type TDrawerModalSC = {
  closeTheme?: 'LIGHT' | 'DARK';
};

export const DrawerModalSC = styled.div<TDrawerModalSC>`
  position: fixed;
  z-index: 99;
  top: 60px;
  right: 0;
  bottom: 0;
  width: 414px;
  background: #fff;
  border-left: 2px solid #f5f5f7;
  overflow-y: auto;
  transition: width 0.3s, transform 0.3s, right 0.4s;
  transform: translateX(100%);

  .dm-back {
    z-index: 99;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: absolute;
    top: 24px;
    right: 24px;
    color: ${({ closeTheme }) => (closeTheme === 'LIGHT' ? '#fff' : theme.colors.font)};

    img {
      width: 8px;
      height: 14px;
      margin-left: 12px;
      transform: rotate(180deg);
    }
  }

  .hd-header {
    padding: 24px 24px 24px;
    background-color: #333d6c;
    border-radius: 0 0 12px 12px;
    z-index: 1;

    .title {
      margin-bottom: 48px;
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;

      /* identical to box height, or 150% */

      color: #fff;

      .text {
        margin-left: 12px;
      }
    }
  }

  .hd-body {
    display: ${isIE11 ? 'block' : 'flex'};
    padding: 24px;
    flex-direction: column;
    flex: 1;
    min-height: 100%;
  }

  .drawer-modal-enter-done & {
    transform: translateX(0%);
  }

  .drawer-modal-enter & {
    transform: translateX(100%);
  }

  .drawer-modal-enter-active & {
    transform: translateX(0%);
  }

  .drawer-modal-exit & {
    transform: translateX(0%);
  }

  .drawer-modal-exit-active & {
    transform: translateX(100%);
  }
`;

export const DrawerModalOverlaySC = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
  background: rgba(255, 255, 255, 0.8);
  transition: opacity 0.4s;

  .drawer-modal-enter-done & {
    opacity: 1;
  }

  .drawer-modal-enter & {
    opacity: 0;
  }

  .drawer-modal-enter-active & {
    opacity: 1;
  }

  .drawer-modal-exit & {
    opacity: 1;
  }

  .drawer-modal-exit-active & {
    opacity: 0;
  }
`;
